import {Text} from '@travel-frontend/core';
import {IconStar} from '@travel-frontend/icons';
import {Flex} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {Container} from '@/components/BestOfferBadge/components/Container';

export const BestOfferBadge: React.FC = () => {
  const {t} = useTranslation('hotels');

  return (
    <Container>
      <Flex
        direction="row"
        alignItems="center"
        gap="8px"
        padding="4px"
        marginLeft="12px"
      >
        <IconStar fontScale="small" />
        <Text preset="labelSmallBold">{t('promotedHotel.bestOffer')}</Text>
      </Flex>
    </Container>
  );
};
